<template>
    <div class="spec-info-body">
		<p>规格明细</p>
		<div>
			<div class="features-btn-box">
				<el-button type="primary" size='small' class="fx-big-btn" plain @click="setDisableFlag(0)">可售</el-button>
				<el-button type="primary" size='small' class="fx-big-btn" plain @click="setDisableFlag(1)">停售</el-button>
			</div>
			<div class="table-box">
				<el-table
					:stripe='false'
					class="grid-content goods-table"
					:data="tableData"
					size='mini'
					max-height="400"
					border
					:row-class-name="tableRowClassName"
					@selection-change="handleSelectionChange">
					<el-table-column
					type="selection"
					align="center"
					width="55">
					</el-table-column>
					<el-table-column
						prop="url"
						align="center"
						min-width="120">
						<template slot="header">
							<div style="position:relative">规格图片
								<el-tooltip class="item" effect="dark" content="图片尺寸最优比例80*80，1M以内，格式：JPG /JPEG / PNG/GIF" placement="top-start">
									<img src="~/images/icon/tooltip-icon.png" class="spec-title">
								</el-tooltip>
							</div>
						</template>
						<template slot-scope="scope">
							<div class="goods-table-info">
								<ImgUplaod
									class="show-img"
									:imgSrc.sync="scope.row.url"
									:imgId.sync="scope.row.id"
									:imgIndex.sync="scope.$index"
									:uploadError.sync="uploadError"
									@preview="preview"
									@updateImg="updateImg"
									ref="showUpload"
								/>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="bcname"
						label="规格名称"
						align="center"
						min-width="180">
						<template>
							<div>
								{{nameName}}
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="spec"
						label="规格数值"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="code"
						label="规格编号"
						align="center"
						min-width="200">
						<template slot-scope='scope'>
							<div>
								<el-input disabled :maxlength='18' v-model="scope.row.code" @input="codeInput(scope.$index)" size="mini"></el-input>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="code"
						label="中台价"
						align="center"
						min-width="200">
						<template slot-scope='scope'>
							<div>
								<el-input disabled :maxlength='18' v-model="scope.row.matchprice" size="mini"></el-input>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="price"
						label="销售价"
						align="center"
						min-width="180">
							<template slot-scope='scope'>
								<div class="table-price">
									<div class="price-input">
										<el-input v-model="scope.row.price" @blur="priceBlur(scope.$index)" size="mini"></el-input>
									</div>
									<span>元</span>
								</div>
							</template>
					</el-table-column>
					<el-table-column
						prop="weight"
						label="重量"
						align="center"
						min-width="160">
							<template slot-scope='scope'>
								<div class="table-weight">
									<el-input v-model="scope.row.weight" size="mini" @blur="weightBlur(scope.$index)"></el-input><span>KG</span>
								</div>
							</template>
					</el-table-column>
					<el-table-column
						v-if="showInventory"
						prop="inventory"
						label="库存"
						align="center"
						min-width="130">
							<template slot-scope='scope'>
								<div>
									<el-input v-model="scope.row.inventory" onkeyup="value=value.replace(/[^\d]/g,'')" size="mini"></el-input>
								</div>
							</template>
					</el-table-column>
					<el-table-column
						prop="minbuycnt"
						label="最小起售量"
						align="center"
						min-width="110">
							<template slot-scope='scope'>
								<div>
									<el-input v-model="scope.row.minbuycnt" size="mini" @blur="minbuycntBlur(scope.$index)"></el-input>
								</div>
							</template>
					</el-table-column>
					<el-table-column
						prop="barcodecount"
						label="条形码"
						align="center"
						min-width="130">
						<template slot-scope='scope'>
							<div class="qrcode-btn" @click="qrClick(scope.row.spec, scope.row.productPlanId, scope.$index,scope.row)">编辑<span class="qrcode-color">（{{scope.row.barcodecount}}个）</span></div>
						</template>
					</el-table-column>
					<el-table-column
						prop="defaultflag"
						label="默认规格"
						align="center"
						min-width="120">
							<template slot-scope='scope'>
								<el-radio v-model="scope.row.defaultflag" :label="true" @change="changeDefault(scope.$index)">默认</el-radio>
							</template>
					</el-table-column>
					<el-table-column
						prop="disabledflag"
						label="可售状态"
						align="center"
						min-width="180">
							<template slot-scope='scope'>
								<el-radio v-model="scope.row.disabledflag" :label="false">可售</el-radio>
								<el-radio v-model="scope.row.disabledflag" :label="true">停售</el-radio>
							</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<el-dialog title="查看图片" class="dialog-title" :visible.sync="showImgModal" width='400px' :close-on-click-modal="false">
			<div style="text-align:center;"><w-image :src="specImg" style="width: 200px; height:200px;display:inline-block;"></w-image></div>
		</el-dialog>
		<el-dialog :title="'【'+ qrSpecName+'】编辑条形码'" class="dialog-title" :visible.sync="qrModal" width='600px' :close-on-click-modal="false">
			<div class="table-box">
					<el-table
					class="grid-content"
					:data="tableDataQR"
					max-height="300"
					size='mini'
					border>
					<el-table-column
					prop="input"
					label="商品条形码"
					align="center"
					width="160">
					<template slot-scope="scope">
						<span>{{scope.row.barcode}}</span>
					</template>
					</el-table-column>
					<el-table-column
					prop="img"
					label="条形码图片"
					align="center">
					<template slot-scope="scope">
						<svg :id="'barcode' + scope.$index" style="height: 62px;"></svg>
					</template>
					</el-table-column>

				</el-table>
			</div>
			<div class="title-btn-box">
				<el-button class="btn" plain type="primary" size='small' @click="qrClose">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import JsBarcode from 'jsbarcode'
import ImgUplaod from '@/components/dock/ImgUploadDetail.vue'
export default {
	name: 'setSpec',
	components: {
		ImgUplaod
	},
	props: {
		SKUType: {
			type: Array,
			default: () => []
		},
		SKUValue: {
			type: Array,
			default: () => []
		},
		productId: {
			type: String,
			default: ''
		},
		showInventory: Boolean
	},
	watch: {
		SKUType (val) {
			let nameArr = []
			val.forEach(e => {
				nameArr.push(e.patname)
			})
			this.nameName = nameArr.join('-')
		},
		SKUValue (val) {
			[...this.tableData] = val
		}
	},
	data () {
		return {
			tableData: [],
			tableHeight: '100%',
			ids: [],
			nameName: '',
			typeOption: [],
			valueName: '',
			valueOption: [],
			valueId: '',
			valueIndex: 0,
			valueTitle: '',
			uploadError: false,
			showImgModal: false,
			specImg: '',
			qrModal: false,
			tableDataQR: [],
			qrSpecName: '',
			qrId: '',
			qrIndex: -1
		}
	},
	created () {
	},
	methods: {
		setData () {
			return new Promise(resolve => {
				resolve(this.tableDataQR)
			})
		},
		// 编辑二维码
		qrClick (name, id, index, row) {
			this.qrSpecName = name
			this.qrId = id
			this.qrIndex = index
			if (this.productId === '') {
				this.qrModal = true
				this.tableDataQR = row.barcode
				this.setData().then(res => {
					console.log(res)
					res.forEach((e, index) => {
						JsBarcode('#barcode' + index, e.barcode, {
							format: 'CODE128', // 条形码的格式
							// lineColor: '#0aa', // 线条颜色
							// width: 4, // 线宽
							height: 20, // 条码高度
							displayValue: true // 是否显示文字信息
						})
					})
				})
				return false
			}
			let params = {
				productPlanId: id,
				id: this.productId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQNV}/match/productBarcode/list`,
				data: params
			}).then(res => {
				if (res.result) {
					this.qrModal = true
					this.tableDataQR = res.data
					this.setData().then(res => {
						console.log(res)
						res.forEach((e, index) => {
							JsBarcode('#barcode' + index, e.barcode, {
								format: 'CODE128', // 条形码的格式
								// lineColor: '#0aa', // 线条颜色
								// width: 4, // 线宽
								height: 20, // 条码高度
								displayValue: true // 是否显示文字信息
							})
						})
					})
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		qrClose () {
			this.qrModal = false
		},
		// 明细编号
		codeInput (index) {
			this.tableData[index].code = this.tableData[index].code.replace(/\\|\'|[\u4E00-\u9FA5]/g, '')
		},
		// 销售价失焦
		priceBlur (index) {
			this.tableData[index].price = this.$fxUtils.toFixedSHW(this.tableData[index].price, 2)
		},
		// 最小起订量失焦
		minbuycntBlur (index) {
			this.tableData[index].minbuycnt = this.$fxUtils.toFixedSHW(this.tableData[index].minbuycnt, 2)
		},
		// 重量失焦
		weightBlur (index) {
			this.tableData[index].weight = this.$fxUtils.toFixedSHW(this.tableData[index].weight, 3)
		},
		// 选择默认
		changeDefault (i) {
			this.tableData.forEach((e, index) => {
				if (i === index) {
					e.defaultflag = true
				} else {
					e.defaultflag = false
				}
			})
		},
		// 规格图片预览
		preview (url) {
			this.specImg = url
			this.showImgModal = true
		},
		// 删除规格图片
		updateImg (index) {
			this.tableData[index].url = ''
		},
		// 批量设置可售停售
		setDisableFlag (type) {
			if (this.ids.length === 0) {
				this.$message.warning('请勾选规格数值！')
				return false
			}
			this.tableData.forEach(e => {
				if (e.checked) {
					e.disabledflag = type === 1
				}
			})
			this.$message.success('勾选【' + this.ids.length + '】个规格已设置' + (type === 0 ? '可售' : '停售') + '状态。保存才可生效！')
		},
		handleSelectionChange (value) {
			let a = value
			this.ids = []
			for (let i = 0; i < a.length; i++) {
				this.ids.push(a[i].productid)
			}
			this.tableData.filter(e => {
				if (value.indexOf(e) > -1) {
					e.checked = true
				} else {
					e.checked = false
				}
			})
		},
		tableRowClassName ({ row, rowIndex }) {
			if (row.checked) {
				return 'check-row'
			}
			return ''
		}
	}
}
</script>
<style lang="stylus">
.price-input {
	.el-input__inner {
		border: 0
	}
}
	.el-table .check-row {
		background: #F3F7FF;
	}
</style>
<style lang="stylus" scoped>
.spec-info-body {
	flex: 1
	text-align left
	p {
		height: 20px
		text-align: left
		line-height 20px
		font-size 15px
		border-left 4px solid var(--fx-primary-color)
		padding-left 8px
		margin 20px 0
		// font-weight 700
	}
	.set-box {
		display: flex
		padding-left: 15px;
		color: #333;
		font-size: 12px;
		.spec-btn {
			width: 120px;
			height: 30px;
			line-height: 30px;
			text-align: center;
			border: 1px solid var(--fx-primary-color);
			border-radius: 4px;
			color: var(--fx-primary-color);
			cursor: pointer
		}
		.spec-btn-disabled {
			width: 120px;
			height: 30px;
			line-height: 30px;
			text-align: center;
			border: 1px solid #999;
			border-radius: 4px;
			color: #999;
			cursor: not-allowed
		}
		.sku-box {
			margin-left: 40px
			display: flex;
			.sku-title {
				padding-top: 5px
				max-width: 65px;
				font-size: 14px;
				flex-shrink: 0
			}
			.sku-set-box {
				display: flex;
				align-items: center;
				.spec-btn {
					margin-left: 15px;
				}
			}
			.sku-name-box {
				padding-left: 15px;
				box-sizing: border-box;
				max-width: 250px;
				&>div {
					display: inline-block;
					margin-top: 10px;
					margin-right: 10px;
					padding: 5px 12px;
					border: 1px solid #CCCCCC;
					border-radius: 4px;
					position: relative
					.delete-sku {
						position: absolute;
						top: -7px;
						right: -8px;
						color: #F56C6C;
						cursor: pointer;
						font-size: 12px;
					}
				}
			}
		}
	}
	.features-btn-box {
		height:40px;
		padding: 0 10px;
		display flex
	}
	.table-box {
		font-size: 12px;
		color: #333
		.spec-title {
			width: 14px;
			height: 14px;
			position: absolute;
			top: 0;
			right: 0;
			cursor: pointer
		}
		.spec-img {
			width: 55px;
			height: 55px;
			display: inline-block;
		}
		.table-weight {
			display:flex;
			align-items: center;
			span {
				width:20px;
				margin-left:5px;
				flex-shrink: 0;
			}
		}
		.table-price {
			display:flex;
			align-items: center;
			.price-input {
				width: 124px;
				height: 32px;
				line-height: 32px;
				border: 1px solid #ebeef5;
				display: flex;
				.price-title {
					display: inline-block;
					width: 47px;
					text-align: center;
					border-right: 1px solid #ebeef5;
					flex-shrink: 0;
				}
				.el-input__inner {
					border: 0
				}
			}
			span {
				width:20px;
				margin-left:5px;
				flex-shrink: 0;
			}
		}
		.qrcode-btn {
			width: 110px;
			height: 32px;
			line-height: 32px;
			border: 1px solid #ebeef5;
			text-align: center;
			cursor: pointer;
			.qrcode-color {
				color: var(--fx-primary-color);
			}
		}
	}
	.title-btn-box{
		height:40px;
		padding:10px;
		box-sizing:border-box;
		text-align:center
		.btn{
			width:130px;
		}
	}
	.reason-box{
        // margin-left :100px;
        height:40px;
        position:relative
    }
    .reason-select{
        position :absolute;
        left:70px;
        top:0px;
        width:250px;
    }
    .reason-input{
        width:220px;
        position :absolute;
        left:71px;
        top:1px;
    }
    .reason-input >>>.el-input__inner {
        height :26px;
        border:none
    }
}
</style>
